import type { LiveLoadSearchSocketEvent } from '@numeo/types-core'

export const LIVE_LOAD_SEARCH_EVENT = 'live-load-search:event'

export type { LiveLoadSearchSocketEvent }
